import { useNavigate } from 'react-router-dom';
import styles from './start.module.scss';
import { useAppStore } from '../../app.context';

const Start = () => {
  const {
    general: { setDevice }
  } = useAppStore();
  const navigate = useNavigate();

  const onClick = (device: 'prime' | 'mid' | 'one') => {
    setDevice(device);
    navigate(`/device-info/${device}`);
  };

  return (
    <div className={styles.main}>
      <h1 className={styles.title}>
        IQOS ILUMA i <br /> Новий рівень взаємодії
      </h1>
      <div className={styles.devices}>
        <div className={styles.device} onClick={() => onClick('prime')}>
          <img
            className={styles.deviceImg}
            src='/img/ILUMA_PRIME_TEASING/prime_i_main.png'
            alt='device'
          />
          <div className={styles.deviceInfo}>
            <p className={styles.deviceName}>IQOS ILUMA i PRIME</p>
            <div className={styles.button}>
              <img src='/img/button.svg' alt='button' />
            </div>
          </div>
        </div>

        <div className={styles.device} onClick={() => onClick('mid')}>
          <img
            className={styles.deviceImg}
            src='/img/ILUMA_MID_TEASING/mid_i_main.png'
            alt='device'
          />
          <div className={styles.deviceInfo}>
            <p className={styles.deviceName}>IQOS ILUMA i</p>
            <div className={styles.button}>
              <img src='/img/button.svg' alt='button' />
            </div>
          </div>
        </div>

        <div className={styles.device} onClick={() => onClick('one')}>
          <img
            className={styles.deviceImg}
            src='/img/ILUMA_ONE_TEASING/one_i_main.png'
            alt='device'
          />
          <div className={styles.deviceInfo}>
            <p className={styles.deviceName}>IQOS ILUMA i ONE</p>
            <div className={styles.button}>
              <img src='/img/button.svg' alt='button' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Start };
